<template>
  <div class="box" :class="$style.hasBorder">
    <form ref="form" id="contact-form" @submit.prevent="onSubmit">
      <fieldset :disabled="isPending">
        <div class="field" :class="{ 'is-horizontal': isHorizontal }">
          <template v-if="isHorizontal">
            <div class="field-label is-normal">
              <label class="label">Nombre *</label>
            </div>
          </template>
          <template v-if="!isHorizontal">
            <label class="label">Nombre *</label>
          </template>
          <template v-if="isHorizontal">
            <div class="field-body">
              <div class="field">
                <div class="control has-icons-left">
                  <input
                    class="input"
                    type="text"
                    placeholder="Nombre y Apellido"
                    v-model="contact.name"
                  />
                  <span class="icon is-small is-left">
                    <font-awesome-icon icon="user" />
                  </span>
                </div>
              </div>
            </div>
          </template>
          <template v-if="!isHorizontal">
            <div class="control has-icons-left">
              <input
                class="input"
                type="text"
                placeholder="Nombre y Apellido"
                v-model="contact.name"
              />
              <span class="icon is-small is-left">
                <font-awesome-icon icon="user" />
              </span>
            </div>
          </template>
        </div>

        <div class="field" :class="{ 'is-horizontal': isHorizontal }">
          <template v-if="isHorizontal">
            <div class="field-label is-normal">
              <label class="label">Email *</label>
            </div>
          </template>
          <template v-if="!isHorizontal">
            <label class="label">Email *</label>
          </template>
          <template v-if="isHorizontal">
            <div class="field-body">
              <div class="field">
                <div class="control has-icons-left">
                  <input
                    class="input"
                    type="email"
                    placeholder="Email de contacto"
                    v-model="contact.email"
                  />
                  <span class="icon is-small is-left">
                    <font-awesome-icon icon="envelope" />
                  </span>
                </div>
              </div>
            </div>
          </template>
          <template v-if="!isHorizontal">
            <div class="control has-icons-left">
              <input
                class="input"
                type="email"
                placeholder="Email de contacto"
                v-model="contact.email"
              />
              <span class="icon is-small is-left">
                <font-awesome-icon icon="envelope" />
              </span>
            </div>
          </template>
          <!-- <p class="help is-danger">This email is invalid</p> -->
        </div>

        <div class="field" :class="{ 'is-horizontal': isHorizontal }">
          <template v-if="isHorizontal">
            <div class="field-label is-normal">
              <label class="label">Empresa *</label>
            </div>
          </template>
          <template v-if="!isHorizontal">
            <label class="label">Empresa *</label>
          </template>
          <template v-if="isHorizontal">
            <div class="field-body">
              <div class="field">
                <div class="control has-icons-left">
                  <input
                    class="input"
                    type="text"
                    placeholder="De cuál empresa nos escribes?"
                    v-model="contact.company"
                  />
                  <span class="icon is-small is-left">
                    <font-awesome-icon icon="building" />
                  </span>
                </div>
              </div>
            </div>
          </template>
          <template v-if="!isHorizontal">
            <div class="control has-icons-left">
              <input
                class="input"
                type="text"
                placeholder="De cuál empresa nos escribes?"
                v-model="contact.company"
              />
              <span class="icon is-small is-left">
                <font-awesome-icon icon="building" />
              </span>
            </div>
          </template>
          <!-- <p class="help is-danger">This email is invalid</p> -->
        </div>

        <div class="field" :class="{ 'is-horizontal': isHorizontal }">
          <template v-if="isHorizontal">
            <div class="field-label is-normal">
              <label class="label">Teléfono contacto</label>
            </div>
          </template>
          <template v-if="!isHorizontal">
            <label class="label">Teléfono contacto</label>
          </template>
          <template v-if="isHorizontal">
            <div class="field-body">
              <div class="field">
                <div class="control has-icons-left">
                  <input
                    class="input"
                    type="text"
                    placeholder="Telefono de contacto"
                    v-model="contact.phone"
                  />
                  <span class="icon is-small is-left">
                    <font-awesome-icon icon="phone" />
                  </span>
                </div>
              </div>
            </div>
          </template>
          <template v-if="!isHorizontal">
            <div class="control has-icons-left">
              <input
                class="input"
                type="text"
                placeholder="Telefono de contacto"
                v-model="contact.phone"
              />
              <span class="icon is-small is-left">
                <font-awesome-icon icon="phone" />
              </span>
            </div>
          </template>
          <!-- <p class="help is-danger">This email is invalid</p> -->
        </div>

        <div class="field" :class="{ 'is-horizontal': isHorizontal }">
          <template v-if="isHorizontal">
            <div class="field-label is-normal">
              <label class="label">Mensaje *</label>
            </div>
          </template>
          <template v-if="!isHorizontal">
            <label class="label">Mensaje *</label>
          </template>
          <template v-if="isHorizontal">
            <div class="field-body">
              <div class="field">
                <div class="control">
                  <textarea
                    class="textarea"
                    placeholder="¿Cómo podemos ayudarte?"
                    rows="2"
                    v-model="contact.message"
                  ></textarea>
                </div>
              </div>
            </div>
          </template>
          <template v-if="!isHorizontal">
            <div class="control">
              <textarea
                class="textarea"
                placeholder="¿Cómo podemos ayudarte?"
                v-model="contact.message"
              ></textarea>
            </div>
          </template>
        </div>

        <div
          class="field is-grouped"
          :class="{ 'is-horizontal': isHorizontal }"
        >
          <template v-if="isHorizontal">
            <div class="field-label">
              <!--  -->
            </div>
          </template>
          <template v-if="isHorizontal">
            <div class="field-body">
              <div class="field">
                <div class="control">
                  <vue-recaptcha
                    ref="recaptcha"
                    :sitekey="reCaptchaKey"
                    @verify="onCaptchaVerified"
                    :loadRecaptchaScript="true"
                    size="invisible"
                  ></vue-recaptcha>
                  <button
                    type="submit"
                    class="button is-primary is-rounded"
                    :class="{ 'is-loading': isPending }"
                  >
                    Enviar
                  </button>
                </div>
              </div>
            </div>
          </template>
          <template v-if="!isHorizontal">
            <div class="control">
              <vue-recaptcha
                ref="recaptcha"
                :sitekey="reCaptchaKey"
                @verify="onCaptchaVerified"
                :loadRecaptchaScript="true"
                size="invisible"
              ></vue-recaptcha>
              <button
                type="submit"
                class="button is-primary is-rounded"
                :class="{ 'is-loading': isPending }"
              >
                Enviar
              </button>
            </div>
          </template>
        </div>
        <small class="text-muted">
          This site is protected by reCAPTCHA and the Google
          <a href="https://policies.google.com/privacy">Privacy Policy</a>
          and
          <a href="https://policies.google.com/terms">Terms of Service</a>
          apply.
        </small>
      </fieldset>
    </form>
  </div>
</template>

<script>
import Vue from "vue";
import { mapActions } from "vuex";
import VueToast from "vue-toast-notification";
import "vue-toast-notification/dist/theme-default.css";
Vue.use(VueToast);
import VueRecaptcha from "vue-recaptcha";

export default {
  name: "ContactForm",
  components: {
    VueRecaptcha,
  },
  props: {
    isHorizontal: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return {
      isPending: false,
      contact: {
        name: null,
        email: null,
        company: null,
        phone: null,
        message: null,
      },
      reCaptchaKey: process.env.VUE_APP_RECAPTCHA_PUBLIC_KEY,
    };
  },
  methods: {
    ...mapActions("root", ["sendContactMessage"]),

    resetForm() {
      Object.keys(this.contact).forEach((key) => (this.contact[key] = null));
    },

    onCaptchaVerified(token) {
      const formData = { ...this.contact, recaptcha: token };
      this.sendContactMessage(formData).then(() => {
        this.isPending = false;
        this.resetForm();
        this.$refs.recaptcha.reset();

        const toastOptions = {
          message: "Tu mensaje fue enviado!",
          type: "info",
          position: "top-right",
        };
        Vue.$toast.open(toastOptions);
      });
    },

    onSubmit() {
      this.isPending = true;
      const toastOptions = {
        message: "Lo sentimos, no se pudo enviar el mensaje",
        type: "error",
        position: "top-right",
      };

      const { name, email, company, message } = this.contact;

      if (name && email && company && message) {
        this.$refs.recaptcha.execute();
      } else {
        this.isPending = false;
        Vue.$toast.open(toastOptions);
      }
    },
  },
};
</script>

<style lang="scss" module>
.hasBorder {
  border: 1px solid;
  border-color: #cccccc;
}
</style>
